import React, { useState, useEffect } from "react";
import "../Styles/About.css";
import "../Styles/Home.css";
import config from "../../config/Config";
import { Helmet } from "react-helmet";
import ListingHero from "./ListingHero";
import ILEARNING from "../../assets/ilearning.png";
export default function About() {
  const [configuration, setConfiguration] = useState([]);
  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setConfiguration(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    fetchConfiguration();
  }, []);

  const metaTitle = configuration[0]?.default_meta_title;
  const metaKeywords = configuration[0]?.default_meta_keywords;
  const metaDescription = configuration[0]?.default_meta_description;
  const siteLabel =
    configuration[0]?.default_meta_title?.split("|")[0]?.trim() || "iLearnings";

  return (
    <div className="home-page page-shell py-4">
      <Helmet>
        <title>About</title>
        <meta name="title" content={metaTitle} />
        <meta name="keywords" content={metaKeywords} />
        <meta name="description" content={metaDescription} />
      </Helmet>

      <ListingHero
        siteLabel={siteLabel}
        badge="Learn · Build · Grow"
        headlinePrefix="Welcome to"
        description="We share practical blogs, tutorials, and resources for developers working with modern web technologies."
        primaryCtaTo="/contact"
        // primaryCtaLabel="Contact us"
        secondaryCtaTo="/blog"
        // secondaryCtaLabel="Explore blogs"
        primaryStat={3}
        primaryStatLabel="Core topics"
        secondaryStat={120}
        secondaryStatLabel="Guides"
        altSecondary={false}
      />

      <div className="row g-4 align-items-center mt-2">
        <div className="col-12 col-lg-6">
          <div className="about-image-frame" data-aos="zoom-in">
            <img src={ILEARNING} className="img-fluid" alt="About ilearnings" />
          </div>
        </div>

        <div className="col-12 col-lg-6" data-aos="fade-up">
          <div className="card about-card p-4 p-md-5">
            <b className="heading_font text_color_heading">Who We Are</b>
            <br />
            <span className="para_font_family">
              Welcome to{" "}
              <a
                href="https://ilearnings.in/"
                target="_blank"
                rel="noopener noreferrer"
                title="ilearnings"
              >
                ilearnings
              </a>{" "}
              your go-to destination for modern web technologies. We publish
              high-quality blogs, tutorials, and resources on Magento, Laravel,
              and database management.
            </span>
            <br />
            <br />
            <b className="heading_font text_color_heading">Our Mission</b>
            <br />
            <span className="para_font_family">
              Our mission is to build a community where technology enthusiasts
              can learn, share, and grow through clear and practical guidance.
            </span>
            <br />
            <br />
            <b className="heading_font text_color_heading">Our Philosophy</b>
            <br />
            <span className="para_font_family">
              We focus on quality and continuous improvement so you get reliable
              learning resources without compromise.
            </span>
          </div>
        </div>
      </div>

      <div className="row mt-4 g-3">
        <div className="col-12" data-aos="fade-up">
          <b className="heading_font text_color_heading">
            Technologies You Cover :-
          </b>
          <div className="mt-2">
            <div>
              <b className="para_font_family">Magento:-</b>
              <span className="para_font_family">
                {" "}
                Tips for customization, PWA development, performance
                optimization, and more.
              </span>
            </div>
            <div className="mt-2">
              <b className="para_font_family">Laravel:-</b>
              <span className="para_font_family">
                {" "}
                Tutorials on building web apps, implementing authentication, and
                advanced features.
              </span>
            </div>
            <div className="mt-2">
              <b className="para_font_family">Database:-</b>
              <span className="para_font_family">
                {" "}
                Insights on design, optimization, queries, and integration with
                modern frameworks.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-3 mb-2 g-3">
        <div className="col-12" data-aos="fade-up">
          <b className="heading_font text_color_heading">
            Lesson-Wise Topics for Blogs :-
          </b>
        </div>

        <div className="col-12 col-lg-4" data-aos="zoom-in" data-aos-delay="80">
          <div className="card card-5 h-100">
            <b className="heading_font p-2 text_color_heading">Magento:-</b>
            <div className="text_family_about p-2">
              <ul className="about-topic-list">
                <li>Installation & setup for beginners</li>
                <li>Customizing Magento themes (practical guide)</li>
                <li>Understanding Magento GraphQL APIs</li>
                <li>Performance optimization techniques</li>
                <li>Magento 2 PWA Studio overview</li>
                <li>Payments integration & troubleshooting</li>
                <li>Extensions, updates & best practices</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-lg-4"
          data-aos="zoom-in"
          data-aos-delay="140"
        >
          <div className="card card-5 h-100">
            <b className="heading_font p-2 text_color_heading">Laravel:-</b>
            <div className="text_family_about p-2">
              <ul className="about-topic-list">
                <li>Setting up your first Laravel project</li>
                <li>Building REST APIs step-by-step</li>
                <li>Authentication: login, register, dashboard</li>
                <li>Working with Eloquent ORM</li>
                <li>Middleware: what it is and how to use</li>
                <li>Validation patterns & best practices</li>
                <li>Advanced topics and real-world examples</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-lg-4"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div className="card card-5 h-100">
            <b className="heading_font p-2 text_color_heading">Databases:-</b>
            <div className="text_family_about p-2">
              <ul className="about-topic-list">
                <li>Relational database basics & concepts</li>
                <li>Designing database schemas (best practices)</li>
                <li>Writing efficient SQL queries</li>
                <li>Relationships: one-to-many, many-to-many</li>
                <li>Indexing & query optimization</li>
                <li>Migrations and schema versioning</li>
                <li>Integrating databases with Laravel</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
